import React from 'react';
import { LinkWithGAClickButton } from '../../../link';
import { downloadCatalogCart, downloadCatalogCartItem } from './download-catalog-cart-styles';

type DownloadCatalogCartProps = {
  catalogHref: string;
  children: React.ReactNode;
  elementBlock: string;
  elementName: string;
  elementText: string;
  linkTitle: string;
};

export const DownloadCatalogCart: React.FC<DownloadCatalogCartProps> = ({
  catalogHref,
  children,
  elementBlock,
  elementName,
  elementText,
  linkTitle,
}) => (
  <li className={downloadCatalogCartItem}>
    <LinkWithGAClickButton
      className={downloadCatalogCart}
      elementBlock={elementBlock}
      elementName={elementName}
      elementText={elementText}
      href={catalogHref}
      target="_blank"
      title={linkTitle}>
      {children}
    </LinkWithGAClickButton>
  </li>
);
